(() => {
  const refreshFoundingCounter = async (root) => {
    if (!root?.id?.startsWith('TPH-')) return;
    const sectionId = root.id.slice(4);
    const currentCount = root.querySelector('.remaining b');
    const currentMeter = root.querySelector('.meter span');
    if (!currentCount && !currentMeter) return;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', sectionId);
      url.searchParams.set('_tp_counter', String(Date.now()));
      const response = await fetch(url.toString(), {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;

      const sections = await response.json();
      const html = sections?.[sectionId];
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshRoot = doc.querySelector('[data-tracepen-home]');
      const freshCount = freshRoot?.querySelector('.remaining b');
      const freshMeter = freshRoot?.querySelector('.meter span');

      if (freshCount && currentCount) {
        currentCount.textContent = freshCount.textContent.trim();
      }
      if (freshMeter && currentMeter) {
        currentMeter.style.width = freshMeter.style.width;
      }
    } catch (_) {
      // Keep the server-rendered value if the refresh request is unavailable.
    }
  };

  const refreshAllFoundingCounters = () => {
    document.querySelectorAll('[data-tracepen-home]').forEach(refreshFoundingCounter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllFoundingCounters, { once: true });
  } else {
    refreshAllFoundingCounters();
  }
  window.addEventListener('pageshow', refreshAllFoundingCounters);
  window.addEventListener('focus', refreshAllFoundingCounters);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshAllFoundingCounters();
  });
})();

(() => {
  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const canvas = root.querySelector('[data-demo-canvas]');
    const space = root.querySelector('[data-demo-workspace]');
    const empty = root.querySelector('[data-demo-empty]');
    if (canvas && space) {
      const ctx = canvas.getContext('2d');
      let drawing = false;
      const resize = () => {
        const r = space.getBoundingClientRect();
        const d = window.devicePixelRatio || 1;
        canvas.width = Math.max(1, r.width * d);
        canvas.height = Math.max(1, r.height * d);
        ctx.setTransform(d, 0, 0, d, 0, 0);
        ctx.lineWidth = 3;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = '#7df42e';
      };
      const point = e => {
        const r = canvas.getBoundingClientRect();
        return [e.clientX - r.left, e.clientY - r.top];
      };
      resize();
      window.addEventListener('resize', resize);
      canvas.addEventListener('pointerdown', e => {
        drawing = true;
        const [x, y] = point(e);
        ctx.beginPath();
        ctx.moveTo(x, y);
        if (empty) empty.hidden = true;
        if (canvas.setPointerCapture) canvas.setPointerCapture(e.pointerId);
      });
      canvas.addEventListener('pointermove', e => {
        if (!drawing) return;
        const [x, y] = point(e);
        ctx.lineTo(x, y);
        ctx.stroke();
      });
      ['pointerup', 'pointercancel'].forEach(n => canvas.addEventListener(n, () => drawing = false));
      root.querySelector('[data-demo-clear]')?.addEventListener('click', () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (empty) empty.hidden = false;
      });
    }

    const exportModal = root.querySelector('[data-export-modal]');
    root.querySelector('[data-demo-export]')?.addEventListener('click', () => exportModal?.showModal());
    root.querySelectorAll('[data-close-export]').forEach(b => b.addEventListener('click', () => exportModal?.close()));

    const modal = root.querySelector('[data-software-modal]');
    const interest = root.querySelector('[data-software-interest]');
    const continueBtn = root.querySelector('[data-continue-order]');
    const status = root.querySelector('[data-order-status]');
    const softwareInfo = modal?.querySelector('p:not(.tpkicker)');

    let variant = '';
    let label = '';
    let softwarePromise = null;

    const setSoftwareState = (state, message) => {
      if (interest) interest.disabled = state !== 'ready';
      if (softwareInfo && message) softwareInfo.textContent = message;
    };

    const loadSoftwareConfig = async () => {
      if (softwarePromise) return softwarePromise;

      softwarePromise = (async () => {
        const response = await fetch(`${window.Shopify.routes.root}products/tracepen-software.js`, {
          headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) throw new Error('Unable to load the TracePen Software subscription.');

        const product = await response.json();
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const groups = Array.isArray(product.selling_plan_groups) ? product.selling_plan_groups : [];
        const plans = groups.flatMap(group =>
          (Array.isArray(group.selling_plans) ? group.selling_plans : []).map(plan => ({ plan, group }))
        );

        const monthly = plans.find(({ plan }) => {
          const optionText = (plan.options || []).map(o => o?.value || '').join(' ');
          return /month/i.test(`${plan.name || ''} ${optionText}`);
        }) || plans[0];

        if (!monthly?.plan?.id) return null;

        const softwareVariant = variants.find(v => {
          const allocations = Array.isArray(v.selling_plan_allocations) ? v.selling_plan_allocations : [];
          return allocations.some(a => Number(a.selling_plan_id) === Number(monthly.plan.id));
        });

        if (!softwareVariant?.id) return null;

        return {
          variantId: Number(softwareVariant.id),
          sellingPlanId: Number(monthly.plan.id),
          planName: monthly.plan.name || 'Monthly',
          price: Number(softwareVariant.price || 1999)
        };
      })();

      return softwarePromise;
    };

    const refreshSoftwareState = async () => {
      setSoftwareState('loading', 'Checking the TracePen Software monthly subscription in Shopify…');
      try {
        const config = await loadSoftwareConfig();
        if (config) {
          setSoftwareState('ready', 'Add TracePen Software for $19.99/month. If selected, it will be added to this Shopify checkout as a recurring monthly subscription.');
        } else {
          setSoftwareState('unavailable', 'TracePen Software subscription setup is not active in Shopify yet. You can continue with the TracePen preorder without software.');
        }
      } catch (e) {
        setSoftwareState('unavailable', 'TracePen Software subscription could not be loaded. You can continue with the TracePen preorder without software.');
      }
    };

    root.querySelectorAll('[data-start-order]').forEach(b => b.addEventListener('click', () => {
      variant = b.dataset.variantId || b.dataset.variant || '';
      label = b.dataset.orderLabel || 'TracePen Founding 100 preorder';
      if (interest) {
        interest.checked = false;
        interest.disabled = true;
      }
      if (status) status.textContent = '';
      modal?.showModal();
      refreshSoftwareState();
    }));

    root.querySelectorAll('[data-close-modal]').forEach(b => b.addEventListener('click', () => modal?.close()));

    continueBtn?.addEventListener('click', async () => {
      if (!variant) {
        if (status) status.textContent = 'Unable to start checkout. Please refresh and try again.';
        return;
      }

      const wantsSoftware = Boolean(interest?.checked && !interest.disabled);
      const original = continueBtn.textContent;
      continueBtn.disabled = true;
      continueBtn.textContent = wantsSoftware ? 'Adding preorder + software…' : 'Adding preorder…';
      if (status) status.textContent = '';

      try {
        const preorderProperties = {
          'Order type': label,
          'Preorder payment': '$2,500',
          'Camera attachment': 'Not included — sold separately'
        };

        const items = [{
          id: Number(variant),
          quantity: 1,
          properties: preorderProperties
        }];

        if (wantsSoftware) {
          const config = await loadSoftwareConfig();
          if (!config) {
            throw new Error('TracePen Software is not configured for monthly subscription checkout yet. Please uncheck software and continue with the preorder.');
          }

          items.push({
            id: config.variantId,
            quantity: 1,
            selling_plan: config.sellingPlanId,
            properties: {
              'Subscription': 'TracePen Software — $19.99/month'
            }
          });
        }

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const d = await response.json().catch(() => ({}));
          throw new Error(d.description || d.message || 'Unable to add TracePen right now.');
        }

        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (e) {
        modal?.close();
        if (status) status.textContent = e.message || 'Unable to add TracePen right now.';
        continueBtn.disabled = false;
        continueBtn.textContent = original;
      }
    });
  }

  document.querySelectorAll('[data-tracepen-home]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector?.('[data-tracepen-home]')));
})();
